export default __webpack_public_path__ + "static/media/unionpay.b01da4d4.svg";